import { createUseStyles } from 'react-jss'

export const style = {
  reportContent: {
    backgroundColor: 'white',
    minHeight: '100vh',
    height: '100%'
  },
  reportContentSafari: {
    minHeight: '100svh'
  },
  reportBody: {
    margin: '0 23px',
    maxWidth: '1024px',
    alignSelf: 'center',
    '& table': {
      margin: '30px auto',
      borderCollapse: 'collapse',
      borderSpacing: '0'
    },
    '& p': {
      margin: '30px auto'
    },
    '& th': {
      borderTop: '1px solid #b2b2b2',
      borderBottom: '2px solid #b2b2b2',
      padding: '3px 6px'
    },
    '& td': {
      padding: '3px 6px'
    }
  }
}

export const useStyles = createUseStyles(style)
